import { getWebEnvObj } from "@/utils";

export const whiteHostReg = /^https?:\/\/[a-zA-Z\-\.]+\.(jdcloud.com|beijing\.e?gov\.cn)/;

const relativePathReg = /^\.?\.?\/.*/;

let authUrl = `${getWebEnvObj().REACT_APP_AUTH_HOST}`;
const authUrlRegex = new RegExp(authUrl);

export const isInWhiteHosts = (url: string) => {
  return authUrlRegex.test(url) || relativePathReg.test(url);
};
